// extracted by mini-css-extract-plugin
export default {"wrapper":"UserFoto_wrapper__sGUBs","listItem":"UserFoto_listItem__GR7-B","listWrapper":"UserFoto_listWrapper__npz1P"};